export const pxToRem = (px, base = 16) => `${px / base}rem`;

/**
 * Convierte una cadena a formato URL friendly (slug)
 * - Elimina código HTML
 * - Convierte a minúsculas
 * - Reemplaza espacios y caracteres especiales por guiones bajos
 * - Elimina acentos y caracteres especiales
 * @param {string} text - Texto a convertir
 * @returns {string} - Texto en formato URL friendly
 */
export const toUrlFriendly = (text) => {
  if (!text) return '';
  
  // Eliminar etiquetas HTML
  const withoutHtml = text.replace(/<[^>]*>/g, '');
  
  // Convertir a minúsculas
  let result = withoutHtml.toLowerCase();
  
  // Reemplazar acentos y caracteres especiales
  const accentsMap = {
    'á': 'a', 'é': 'e', 'í': 'i', 'ó': 'o', 'ú': 'u',
    'à': 'a', 'è': 'e', 'ì': 'i', 'ò': 'o', 'ù': 'u',
    'ä': 'a', 'ë': 'e', 'ï': 'i', 'ö': 'o', 'ü': 'u',
    'â': 'a', 'ê': 'e', 'î': 'i', 'ô': 'o', 'û': 'u',
    'ñ': 'n', 'ç': 'c'
  };
  
  result = result.split('').map(char => accentsMap[char] || char).join('');
  
  // Reemplazar espacios y caracteres no alfanuméricos por guiones bajos
  result = result.replace(/[^a-z0-9]+/g, '_');
  
  // Eliminar guiones bajos al inicio y al final
  result = result.replace(/^_+|_+$/g, '');
  
  // Reemplazar múltiples guiones bajos consecutivos por uno solo
  result = result.replace(/_+/g, '_');
  
  return result;
};